module.exports = __webpack_public_path__ + "static/logo-47f79ba4abaa5af9d171c6b5fd3cf13a.jpg";